import React from 'react';

import { ProfilFourriereViolationDtoFormFieldEnum } from 'lib_api/lib/api/gen';

import { Input } from 'components/WrappedComponents';
import { useApi } from 'hooks/ApiStoreContext';
import { useUserStore } from 'hooks/UserStoreContext';
import { FormPlaceholders } from 'types/enums/FormPlaceholders';
import {
  FicheProfilFourriereBlocFourriere,
  InputPropFourriere,
} from 'types/FicheProfil/FicheProfilGardienFourriere';
import { CSSUtils } from 'utils/CSSUtils';

import { validateFicheProfilGf } from '../../utils';

function InputZIPCode({
  values,
  isEditable,
  generateRequestDto,
}: InputPropFourriere): React.ReactElement {
  const user = useUserStore();
  const gfController = useApi().GardienFourriereControllerApi;
  const key: keyof FicheProfilFourriereBlocFourriere = 'zipCode';
  const label = 'Code postal';

  return (
    <Input
      wrapperProps={{
        values: values,
        fieldKey: key,
        itemProps: {
          getValueFromEvent: (
            event: React.ChangeEvent<HTMLInputElement>,
          ): string => {
            const reg = new RegExp('^[0-9]*$');
            if (!reg.test(event.currentTarget.value)) {
              return event.currentTarget.defaultValue;
            }
            return event.currentTarget.value;
          },
          label: label,
          rules: [
            {
              required: true,
              validator: async (
                _rule,
                value: string | undefined,
              ): Promise<void> => {
                return validateFicheProfilGf(
                  gfController,
                  ProfilFourriereViolationDtoFormFieldEnum.CODE_POSTAL,
                  user.idCorrelationFourriere || '',
                  generateRequestDto({ ...values, [key]: value }),
                );
              },
            },
          ],
          labelCol: { span: CSSUtils.defaultLabelCol },
          wrapperCol: { span: CSSUtils.largeWrapperCol },
        },
        editable: isEditable,
      }}
      inputProps={{
        placeholder: FormPlaceholders.Input,
      }}
    />
  );
}

export default InputZIPCode;
